import React, { ComponentProps } from 'react';
import styled from 'styled-components';
import { ButtonTertiary } from '@spotify-internal/encore-web';
import * as tokens from 'styles';

const Button = styled(ButtonTertiary)`
  padding-top: 0;
  cursor: pointer;
  color: inherit;

  &:before {
    content: '<';
    margin-right: ${tokens.spacer4};
  }
`;

type BackProps = ComponentProps<typeof ButtonTertiary>;

const Back = ({ children, ...props }: BackProps) => (
  <Button {...props}>{children}</Button>
);

export default Back;
